/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerFindOneQueryResponse, AnswersControllerFindOnePathParams, AnswersControllerFindOneQueryParams, AnswersControllerFindOne400, AnswersControllerFindOne401, AnswersControllerFindOne403, AnswersControllerFindOne404 } from "../../models/checklistsController/AnswersControllerFindOne";

function getAnswersControllerFindOneUrl(id: AnswersControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-answers/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist answer by ID
 * {@link /api/v1/checklist-answers/:id}
 */
export async function answersControllerFindOne(id: AnswersControllerFindOnePathParams["id"], params?: AnswersControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AnswersControllerFindOneQueryResponse, ResponseErrorConfig<AnswersControllerFindOne400 | AnswersControllerFindOne401 | AnswersControllerFindOne403 | AnswersControllerFindOne404>, unknown>({ method : "GET", url : getAnswersControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}